import './Contact.css';
import {
    Row,
    Col
} from 'react-bootstrap';
import { FooterCopyright } from '../components/footer/Footer';
import Translator from '../translates/Translator';
import hexes from '../assets/img/hexes';
import usePageMeta from '../hooks/usePageMeta';

const Contact = () => {
    const t = Translator();
    usePageMeta(`${t("contact")} | IKA DATA`, t("seo-contact-description"));
    const linkedinURL = 'https://www.linkedin.com/company/ika-data-spol-s-r-o-/';

    return (
        <div>
            <Row className='contact flex-column flex-lg-row'>
                <Col xs={12} lg={7} className='contact-info pb-3'>
                    <Row className='mb-3'>
                        <Col xs={2} className=''>
                            <i className="fa-solid fa-pen-to-square fa-2xl"></i>
                        </Col>
                        <Col>
                            <span className='fs-5'>IKA DATA, spol. s r.o.</span><br />
                            Vinohradská 1899/112,
                            130 00 Praha 3<br />
                            IČ: 26155664
                        </Col>
                    </Row>
                    <Row className='mb-5'>
                        <Col xs={2} className=''>
                            <i className="fa-brands fa-linkedin fa-2xl"></i>
                        </Col>
                        <Col>
                            <a href={linkedinURL} target='_blank' rel="noreferrer">
                                {t("linkedin-information")}
                            </a>
                        </Col>
                    </Row>
                    <Row className='mb-3'>
                        <Col xs={2} className=''>
                            <i className="fa-solid fa-mobile-screen-button fa-2xl"></i>
                        </Col>
                        <Col>
                            Tel.: <a href="tel:+420601563562" className=''>+420 601 563 562</a> <br />
                            Helpdesk: <a href="tel:+420771506197" className=''>+420 771 506 197</a>
                        </Col>
                    </Row>
                    <Row className='mb-5'>
                        <Col xs={2} className=''>
                            <i className="fa-regular fa-envelope fa-2xl"></i>
                        </Col>
                        <Col>
                            <a href="mailto:sluzby@ikadata.com" className=''>Sluzby@ikadata.com</a> <br />
                            <a href="mailto:helpdesk@ikadata.com" className=''>Helpdesk@ikadata.com</a>
                        </Col>
                    </Row>
                    <Row className='mb-3'>
                        <Col xs={2} className=''>
                            <i className="fa-solid fa-location-dot fa-2xl"></i>
                        </Col>
                        <Col>
                            U Průhonu 773/12, 170 00 Praha 7 - Holešovice
                        </Col>
                    </Row>
                </Col>
                <img src={hexes.h3_80} className="hex3 o-50" alt='' />
                <Col className='map-div p-0'>
                    <iframe
                        title="Address Map"
                        style={{ border: "0", width: "100%", height: "100%" }}
                        loading="lazy"
                        referrerPolicy="strict-origin-when-cross-origin"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3253.4684760551596!2d14.445219756308369!3d50.10458596831685!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470b9362c3ef85d1%3A0x6c36658b86cec876!2sIKA%20DATA%2C%20spol.%20s.r.o.!5e0!3m2!1sen!2scz!4v1786440412223!5m2!1sen!2scz"
                        allowFullScreen={true}>
                    </iframe>
                </Col>
            </Row>
            <FooterCopyright />
        </div>
    );
};

export default Contact;